import { http } from '@/http'
import { imgServe } from '@/imageServe'

const PATH = 'app/collabs/'

class CollabService {
  async getFighters () {
    return http.get('app/all-fighters')
  }

  async getFightersById (id) {
    return http.get(`app/fighters-by/${id}`)
  }

  async deleteFighter (id) {
    return http.delete(`app/remove-fighter/${id}`)
  }

  async getEvents () {
    return http.get('app/events-combo')
  }

  async editFighter (data) {
    return http.post('app/upstore-customer', data)
  }

  async register (data) {
    return http.post(PATH.concat('new'), data, {
      headers: {
        __user: localStorage.getItem('__uuid')
      }
    })
  }

  async getCollabById (id) {
    return http.get(PATH.concat(id).concat('/collab'))
  }

  async saveImage (newImg) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem('__company')
      }
    }

    return imgServe.post('new-file', { file: newImg }, headers)
  }

  async editImage (newImg, imgPath) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem('__company'),
        __company_path: imgPath
      }
    }

    return imgServe.post('replace-file', { file: newImg }, headers)
  }

  async getPermissions () {
    return http.get(PATH.concat('permissions'))
  }
}

export default new CollabService()
export { PATH }
